import { ReactComponent as SearchSvg } from 'assets/search.svg';
import './styles.scss';

const SearchButton = () => {
  return (
    <button type="submit" className="searchButton">
      <SearchSvg />
    </button>
  );
};

export default SearchButton;
